import React, {useState} from "react";
import moment from "moment";
import TimelineChart from "./TimelineChart";
import DatePicker from "react-datepicker";

function ResellerValueSum({modelId, humanReadableName, url}) {
    const [saleSum, setSaleSum] = useState("");
    const [startDate, setStartDate] = useState(moment().add(-1, "M"));
    const [endDate, setEndDate] = useState(moment());
    const [startDatePicker, setStartDatePicker] = useState(moment(startDate).toDate());
    const [endDatePicker, setEndDatePicker] = useState(moment(endDate).toDate());

    function onDateChange(dates) {
        setStartDate(moment(dates[0]));
        setEndDate(moment(dates[1]));

        setStartDatePicker(dates[0] ? moment(dates[0]).toDate() : null);
        setEndDatePicker(dates[1] ? moment(dates[1]).toDate() : null);
    }

    return <div className="col-md-6">
        <div className="card border-bottom shadow border-info">
            <div className="card-body">
                <div className="d-flex no-block align-items-center">
                    <div>
                        <h6 className="text-info">{humanReadableName} in selected date range</h6>
                    </div>
                    <div className="ml-auto">
                        <h2>{saleSum}</h2>
                    </div>
                </div>
                <TimelineChart
                    startDate={startDate}
                    endDate={endDate}
                    modelId={modelId}
                    onSaleSumUpdated={(saleSum) => setSaleSum(saleSum)}
                    url={url}
                />
                <DatePicker
                    selectsRange
                    startDate={startDatePicker}
                    endDate={endDatePicker}
                    onChange={onDateChange}
                    dateFormat="dd/MM/yyyy"
                    className="form-control"
                />
            </div>
        </div>
    </div>
}

export default ResellerValueSum
